// src/components/User.js
import React from 'react';
import { ChevronDown } from 'react-feather';

export default function User({ name, filingStatus, onOpenModal }) {
  return (
    <div className="sidebar-header">
      <button className="user-profile-button" onClick={onOpenModal}>
        <img src="/avatar.png" alt="User Avatar" />
        <div className="user-info">
          {/* CHANGED: Use the prop or fallback */}
          <span className="truncate" style={{ maxWidth: '120px' }}>
            {name || 'Your Name'}
          </span>
          <small className="current-status">{filingStatus}</small>
        </div>
        <ChevronDown size={16} className="profile-chevron" />
      </button>
    </div>
  );
}